import Cookies from 'js-cookie'
import { REOPEN_QUESTIONNAIRE_EXPIRE_TIME } from '@/utils/constant'

const zhongshan = {
  state: {
    hasShowQuestionnaire: Cookies.get('hasShowQuestionnaire') || false,
    showQuestionnaire: false
  },
  mutations: {
    SET_HAS_SHOW_QUESTIONNAIRE: (state, hasShowQuestionnaire) => {
      state.hasShowQuestionnaire = hasShowQuestionnaire;
    },
    SET_SHOW_QUESTIONNAIRE: (state, showQuestionnaire) => {
      state.showQuestionnaire = showQuestionnaire;
    }
  },
  actions: {
    // 打开调查问卷弹窗
    openQuestionnaireDialog({ commit }){
      commit('SET_HAS_SHOW_QUESTIONNAIRE', true);
      commit('SET_SHOW_QUESTIONNAIRE', true);
      // 缓存弹窗flag到cookie，24小时的有效期内不再弹出调查问卷
      Cookies.set('hasShowQuestionnaire', true, { expires: REOPEN_QUESTIONNAIRE_EXPIRE_TIME })
    },
    closeQuestionnaireDialog({ commit }){
      commit('SET_SHOW_QUESTIONNAIRE', false);
    }
  }
}

export default zhongshan;




// WEBPACK FOOTER //
// ./src/store/module/zhongshan.js